import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import arrow from "../../../../static/chevron-down.svg";
import savedarrow from "../../../../static/icon-arrow-triangle-up.svg";
import Collapse from "@material-ui/core/Collapse";
import { withTranslation, Trans } from "react-i18next";
import Backdrop from "@material-ui/core/Backdrop";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { withStyles } from "@material-ui/core/styles";
import {
  Set_Pickup_Inputs,
  Set_Pickup_address,
  Set_SearchAutoCompleteLoading,
  Set_latlng,
  ChooseoOnMapimg,
  SetopenAddressBookInNewOrder,
  SetopenNewAddressBookInNewOrder,
  SetNewAddressBookInNewOrderDetails,
  SetSelectedAB,
  Set_Map_Geocoding,
} from "../../../../Redux/actions/actionNames";
import {
  SearchAutoCompleteAction,
  SearchAddressAction,
  // PlaceIdDetailsAction,
  // getFavAddressInfoAction,
} from "../../../../Redux/actions/actions";
import closeCircle from "../../../../static/close-cricle.svg";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import CircularProgress from "@material-ui/core/CircularProgress";
import Schedule from "./Schedule";
import momentJalaali from "moment-jalaali";
import { get_customerPannel_type, get_lang, Get_Permisssion } from "../../../../helper/UserData/userdate";
import {
  Api_map_geocoding_reverse_AGW,
  Api_PlaceIdDetails_AGW,
  Api_SearchAutoComplete_AGW,
} from "../../../../helper/api/ApiGateway";
import { isDesktop, isMobile, isTablet } from "react-device-detect";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { getCenterMap, getCountryWithDomain, setCenterMap } from "../../../../helper/module";
// import { ReactComponent as Abookmark } from "../../../../static/iconly-bulk-bookmark.svg";
import { ReactComponent as UAbookmark } from "../../../../static/iconly-light-outline-bookmark.svg";
import { isEmpty } from "lodash";
import { v4 as uuidv4 } from 'uuid';
import AddressbookListSvg from "../../../../components/svg/addressbookSvg";
import IconIcPinSvg from "../../../../components/svg/icon-ic-pinSvg";
import IconlyBulkBookmarkSvg from "../../../../components/svg/iconly-bulk-bookmarkSvg";

const BackdropCustom = withStyles({
  backdrop: {
    zIndex: 5000,
    backgroundColor: "rgba(0, 0, 0, 0)",
    color: "#00000",
  },
})((props) => (
  <Backdrop
    {...props}
    style={{
      zIndex: 5000,
      backgroundColor: "rgba(0, 0, 0, 0)",
      color: "#00000",
    }}
  />
));

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "pickup",
      loading: false,
      ordered: true,
      showpoper: false,
      showpoperSaved: false,
      getFavAddressLoading: false,
      searchAddrees: "",
      list: [0, 1, 2, 3, 5, 6, 9, 5, 8],
      sessionToken: null
    };
    this.anchorEl = React.createRef();
    this.mapSetView = this.mapSetView.bind(this);
  }

  openAddressbook = () => {
    if (this.UserHavePermission()) {
      if (this.props.openAddressBook && this.props.addressBookSource) {
        this.props.dispatch(SetopenAddressBookInNewOrder(false, "", null, ""));
      } else {
        this.props.dispatch(
          SetopenAddressBookInNewOrder(true, "pickup", null, "AddressbookPickup")
        );
      }
    }

  };

  handleshowpoper = () => {
    this.UserHavePermission() &&
      this.setState({
        showpoper: !this.state.showpoper,
        searchAddrees: "",
        showpoperSaved: false,
      });
  };

  handleshowpoperDrop = () => {
    this.setState({
      showpoperSaved: !this.state.showpoperSaved,
      searchAddrees: "",
      showpoper: false,
    });
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.adresss_loc.lat != nextProps.adresss_loc.lat) {
      this.setState({
        showpoper: false,
      });
    }
  }

  handleSavedDropInput = (e) => {
    this.setState({
      searchAddrees: e.target.value,
    });
  };

  componentDidMount() {
    this.props.setId(this.state.id);
  }

  idgenerator = () => {
    var number = Math.random(); // 0.9394456857981651
    number.toString(36); // '0.xtis06h6'
    var id = number.toString(36).substr(2, 9); // 'xtis06h6'
    return id.toString();
  };

  handleCollapse = () => {
    if (isDesktop || isTablet) {
      if (this.props.activePickupDropOff.type === "pickup") {
        this.props.handleCollapse({
          type: "pickup",
          id: "pickup",
        });
      } else {
        this.props.handleCollapse({
          type: "pickup",
          id: "pickup",
        });
      }
    } else {
      this.props.handleCollapse({
        type: "pickup",
        id: "pickup",
      });
    }
  };

  validate(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  handlePickUpInputs = (e, name) => {

    let center = getCenterMap(this.props.mapRef, this.props.center);
    if (this.UserHavePermission()) {
      if (name === "address" || e.target.id === "address") {

        this.setState({
          sessionToken: this.state.sessionToken ? this.state.sessionToken : uuidv4()
        })

        this.setState({
          showpoper: true
        })
        this.props.dispatch(
          Set_Pickup_address({
            adresss_loc: { lng: "", lat: "" },
            placeId: "",
          })
        );
        this.props.dispatch(Set_SearchAutoCompleteLoading(true));
        if (e.target.value != "") {
          e.target.value.length > 2 && Api_SearchAutoComplete_AGW(this.props.dispatch, {
            query: e.target.value,
            latitude: this.props.mapRef.current
              ? center.lat
              : this.props.center.lat,
            longitude: this.props.mapRef.current
              ? center.lng
              : this.props.center.lng,
            sessionToken: this.state.sessionToken

          });
        }
      }
      this.props.dispatch(
        Set_Pickup_Inputs({
          name: name || e.target.id,
          value: e.target.value,
        })
      );
    }
  };

  handleList = (item) => {
    if (item.coordinates) {
      this.props.dispatch(
        Set_Map_Geocoding({
          address: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
        })
      );

      this.props.dispatch(
        Set_Pickup_address({
          ...item,
          address: item.secondaryAddress
            ? item.address + " , " + item.secondaryAddress
            : item.address,
          adresss_loc: { lng: item.coordinates[0], lat: item.coordinates[1] },
        })
      );
      this.mapSetView({
        lng: item.coordinates[0],
        lat: item.coordinates[1],
      });

      this.setState({
        sessionToken: null
      })


    } else {

      this.setState({
        sessionToken: this.state.sessionToken ? this.state.sessionToken : uuidv4()
      }, () => {

        Api_PlaceIdDetails_AGW(
          this.props.dispatch,
          { placeId: item.placeId, sessionToken: this.state.sessionToken },
          (res) => {
            this.mapSetView({ lng: res.coordinates[0], lat: res.coordinates[1] });
            this.props.dispatch(
              Set_Map_Geocoding({
                address: res.address,
              })
            );

            this.props.dispatch(
              Set_Pickup_address({
                ...item,
                address: res.address,
                adresss_loc: { lng: res.coordinates[0], lat: res.coordinates[1] },
              })
            );
            this.props.dispatch(
              Set_latlng({
                lng: res.coordinates[0],
                lat: res.coordinates[1],
              })
            );
          }
        );

      })



    }

    if (this.props.activePickupDropOff.type != "pickup") {
      this.props.handleCollapse({
        type: "pickup",
        id: "pickup",
      });
    }
  };

  resetPickup = () => {
    this.props.dispatch(
      Set_Pickup_address({
        address: "",
        adresss_loc: { lng: "", lat: "" },
        placeId: "",
      })
    );
  };

  mapSetView = (e) => {
    console.log("setCenterMap ", this.props.mapRef, e)

    try {
      setCenterMap(this.props.mapRef, e)
      // this.props.mapRef.current.leafletElement.setView(e, 17);
    } catch (error) {
      this.props.dispatch(
        Set_latlng({
          lng: e.lng,
          lat: e.lat,
        })
      );
    }
  };

  ChooseoOnMapimg = () => {
    if (this.UserHavePermission()) {
      if (
        this.props.pickupDropOffType &&
        this.props.pickupDropOffType == "Pickup"
      ) {
        this.props.dispatch(
          ChooseoOnMapimg({
            showMap: false,
            pickupDropOff: {
              type: null,
              id: null,
            },
          })
        );
      } else {
        let center = getCenterMap(this.props.mapRef, this.props.center);
        Api_map_geocoding_reverse_AGW(this.props.dispatch, {
          latitude: this.props.mapRef.current
            ? center.lat
            : this.props.center.lat,
          longitude: this.props.mapRef.current
            ? center.lng
            : this.props.center.lng,
        });

        this.props.dispatch(
          ChooseoOnMapimg({
            showMap: true,
            pickupDropOff: {
              type: "Pickup",
              id: null,
            },
          })
        );
      }
    }

  };

  phoneNumberOnChange = (res, id) => {
    if (this.UserHavePermission()) {
      this.props.dispatch(
        Set_Pickup_Inputs({
          name: id,
          value: res.target.value,
        })
      );
    }
  };

  handleNewBookmark = () => {
    if (this.UserHavePermission()) {
      if (!this.checkInputFilledByAB()) {
        this.props.dispatch(SetopenNewAddressBookInNewOrder(true, "pickup"));
        this.props.dispatch(
          SetopenAddressBookInNewOrder(false, null, null, null)
        );
        let phone = this.props.senderPhoneNumber;
        if (phone && phone.length > 2 && phone.substring(0, 2) == "00") {
          phone = "+" + phone.substring(2, phone.length)
        }
        this.props.dispatch(
          SetNewAddressBookInNewOrderDetails({
            address: this.props.address,
            adresss_loc: this.props.adresss_loc,
            block: this.props.block,
            floor: this.props.floor,
            unit: this.props.unit,
            FullName: this.props.senderFullName,
            PhoneNumber: phone,
            description: this.props.noteForDriver,
            email: this.props.email
          })
        );
      }
    }

  };

  checkInputFilledByAB = () => {
    let status = false;
    this.props.Addressbooklist.forEach((element) => {
      if (element.address == this.props.address) {
        status = true;
      }
    });
    return status;
  };

  UserHavePermission = () => {

    if (get_customerPannel_type() == "business") {
      if (Get_Permisssion()?.isDefaultPickupAddressEditable) {
        return true
      } else if (this.props.adresss_loc.lat == '') {
        return true
      } else {
        return false
      }


    } else {
      return true
    }
  };

  render() {
    const { t } = this.props;
    let originShow =
      this.props.pickupDropOffType && this.props.pickupDropOffType == "Pickup";

    return (
      <passerngerContainer className="pickupCustomized">
        <pickuptitle ref={this.anchorEl} style={{ height: "auto" }}>
          <Trans i18nKey={"Pickup"}> </Trans>


          <div style={{ float: "left", width: "100%", marginTop: "12px" }} className="eppffbkd">

            <span
              className={`ChooseoOnMap ${!originShow && "nobackGround"}  ${!this.UserHavePermission() && "noPermission"}`}
              onClick={this.ChooseoOnMapimg}
            >
              <IconIcPinSvg className="ChooseoOnMapimg" />
              {/* <img src={chooseoOnMap}  /> */}
              <span className={`ChooseoOnMapText `} style={{ color: global.config.colors.primaryOnLight }}>
                {" "}
                <Trans i18nKey={"ChooseoOnMap"}> </Trans>{" "}
              </span>
            </span>

            <div
              className={`AddressbookContainerPickup ${this.props.addressBookSource && "AddressbookContainerPickupActive"
                }    ${!this.UserHavePermission() && "noPermission"}  `}
              onClick={() => this.openAddressbook()}
            >
              <AddressbookListSvg className="img" style={{
                transform: "scale(.7)", marginTop: "-3px"
              }} />
              {/* <img src={newAddressbook} /> */}
              <span style={{ color: global.config.colors.primaryOnLight }}>
                {" "}
                <Trans i18nKey={"Addressbook"}> </Trans>{" "}
              </span>
            </div>
          </div>

          {/* <Addressbook ShowComponentMenu={true} onclose={this.onclose} source="pickup"  /> */}
        </pickuptitle>

        <div className={`pickupInputContainer `}>
          <input
            value={this.props.address}
            onChange={(e) => this.handlePickUpInputs(e, "address")}
            className={`addressPickup ${this.props.adresss_loc.lat !== "" && "negative50"
              }`}
            onClick={this.handleshowpoper}
            placeholder={t("address")}
          />

          {this.checkInputFilledByAB() ?
            <IconlyBulkBookmarkSvg onClick={this.handleNewBookmark} className={`x1 Abookmark ${(this.props.address.length <= 0 || this.checkInputFilledByAB()) &&
              "UAbookmark"
              }  ${!this.UserHavePermission() && "noPermission"} ${this.checkInputFilledByAB() && "AbookmarkActive"} `} />
            : <UAbookmark onClick={this.handleNewBookmark} className={`x2 Abookmark ${(this.props.address.length <= 0 || this.checkInputFilledByAB()) &&
              "UAbookmark"
              }  ${!this.UserHavePermission() && "noPermission"}`} />}



          {(this.props.adresss_loc.lat !== "" && this.UserHavePermission()) && (
            <img
              className={"resetPickup"}
              src={closeCircle}
              onClick={this.resetPickup}
            />
          )}
        </div>

        <img
          onClick={this.handleCollapse}
          src={arrow}
          className={`pickupCollIconVR ${this.props.activePickupDropOff.type === "pickup" && "rotate180"
            } `}
        />
    

        <Collapse
          className="pickupcollapsecontainer"
          style={{ width: '100%' }}
          in={this.props.activePickupDropOff.type === "pickup"}
          timeout="auto"
          unmountOnExit
        >
          {this.props.isAddressDetailsActive ? (
            <React.Fragment>

              {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressRoomFloorBlockActive && (this.props.serviceactiveVehicleType && this.props.serviceactiveVehicleType.orderTypes.indexOf("PickupDelivery") == -1)) && <>

                <input
                  value={this.props.block}
                  onChange={this.handlePickUpInputs}
                  id="block"
                  name="5a7a593f"
                  autocomplete="5a7a593f"
                  className="blockPickup"
                  placeholder={t("block")}
                />
                <input
                  value={this.props.floor}
                  onChange={this.handlePickUpInputs}
                  id="floor"
                  name="9e26dc9a"
                  autocomplete="9e26dc9a"
                  className="floorPickup"
                  placeholder={t("Floor")}
                />
                <input
                  value={this.props.unit}
                  onChange={this.handlePickUpInputs}
                  id="unit"
                  name="cf0d4937"
                  autocomplete="cf0d4937"
                  className="UnitPickup"
                  placeholder={t("Unit")}
                />

              </>}

              {(this.props.serviceactiveVehicleType && this.props.serviceactiveVehicleType.orderTypes.indexOf("PickupDelivery") > -1) &&
                <div className="inputWithRequired" >
                 
                <input
                  value={this.props.addressDetails}
                  name="abd27ae9"
                  autocomplete="abd27ae9"
                  onChange={this.handlePickUpInputs}
                  id="addressDetails"
                  className="senderfullnamePickup"
                  placeholder={t("Addressdetails")}
                />

                 
                </div>}
              {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressNameActive) && <div className="inputWithRequired">

                <input
                  value={this.props.senderFullName}
                  name="abd27ae9"
                  autocomplete="abd27ae9"
                  onChange={this.handlePickUpInputs}
                  id="senderFullName"
                  className="senderfullnamePickup"
                  placeholder={t("senderfullname")}
                />

                {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressNameRequired) && <span className="inputRequired">{this.props.t("Required")}</span>
                }
              </div>}

              {/* <input
                    value={this.props.senderPhoneNumber}
                    name="98d5c240"
                    autocomplete="98d5c240"
                    onChange={this.handlePickUpInputs}
                    id="senderPhoneNumber"
                    className="senderphonenumberPickup"
                    placeholder={t("senderphonenumber")}
                    type="number"
                  /> */}

              {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressEmailActive) && <div className="inputWithRequired"
                style={{ border: this.props.email.length > 0 ? this.validate(this.props.email) ? "solid 1px rgba(128, 128, 128, 0.2)" : "1px solid red" : "solid 1px rgba(128, 128, 128, 0.2)" }}
              >
                <input
                  value={this.props.email}
                  name="4efb28c6dw"
                  autocomplete="4efb28c6dw"
                  onChange={this.handlePickUpInputs}
                  id="email"
                  className="notesfordriverPickup"
                  placeholder={t("email")}
                // style={{border: this.props.email.length > 0 ?  this.validate(this.props.email) ? "solid 1px rgba(128, 128, 128, 0.2)" : "1px solid red" :  "solid 1px rgba(128, 128, 128, 0.2)"}}
                />

                {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressEmailRequired) && <span className="inputRequired">{this.props.t("Required")}</span>
                }
              </div>}
              {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressPhoneActive) &&
                <div className="inputWithRequired" >

<input
                    value={this.props.senderPhoneNumber}
                    name="4efb28c6dw"
                  autocomplete="4efb28c6dw"
                  onChange={(PrePhoneInput) =>
                    this.phoneNumberOnChange(PrePhoneInput, "senderPhoneNumber")
                  }
                  id="emasenderPhoneNumberil"
                  type="text"
                  className="senderphonenumberPickup"
                  placeholder="123456789"
                  // style={{border: this.props.email.length > 0 ?  this.validate(this.props.email) ? "solid 1px rgba(128, 128, 128, 0.2)" : "1px solid red" :  "solid 1px rgba(128, 128, 128, 0.2)"}}
                />
                  {/* <PhoneInput
                    defaultCountry={global.config.Country}
                    placeholder="123456789"
                    value={this.props.senderPhoneNumber}
                    onChange={(PrePhoneInput) =>
                      this.phoneNumberOnChange(PrePhoneInput, "senderPhoneNumber")
                    }
                    id="senderPhoneNumber"
                    className="senderphonenumberPickup"
                    disabled={!this.UserHavePermission()}
                  /> */}

                  {(this.props.activeVehicleType && this.props.activeVehicleType.setting && this.props.activeVehicleType.setting.isPickupAddressPhoneRequired) && <span className="inputRequired">{this.props.t("Required")}</span>
                  }
                </div>}
              {(this.props.serviceactiveVehicleType && this.props.serviceactiveVehicleType.orderTypes.indexOf("PickupDelivery") == -1) && <div className="inputWithRequired" >
                <input
                  value={this.props.noteForDriver}
                  name="4efb28c6"
                  autocomplete="4efb28c6"
                  onChange={this.handlePickUpInputs}
                  id="noteForDriver"
                  className="notesfordriverPickup"
                  placeholder={t("notesfordriver")}
                />
              </div>}

            </React.Fragment>
          ) : null}
          <div style={{ width: "479px" }}>
            {this.UserHavePermission() && <Schedule
              scheduleDateBefore={this.props.scheduleDateBefore}
              scheduleDateAfter={this.props.scheduleDateAfter}
            />}
          </div>
        </Collapse>

        <BackdropCustom
          open={this.state.showpoper}
          onClick={this.handleshowpoper}
        >
          <Popper
            style={{
              width: "475px",
              zIndex: "7",
              marginTop: "0px",
              maxHeight: "150x",
              minHeight: "87px",
              left: "25px !important",
            }}
            placement={"bottom"}
            id={"passenger"}
            open={this.state.showpoper}
            anchorEl={this.anchorEl.current}
            className=" pickupAddressPoperList"
          >
            <Paper
              className="xxx"
              style={{
                width: "100%",
                float: "right",
                borderRadius: "8px",
                paddingTop: "5px",
                marginTop: "10px",
                right: "271px",
                maxHeight: "150px",
                overflowY: "scroll",
                overflowX: "hidden",
              }}
              elevation={3}
            >
              <div
                style={{
                  maxHeight: "150px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                {this.props.suggestPickUpDropOffListData.length > 0 &&
                  !this.props.suggestListPickUpDropOffLoading &&
                  this.props.suggestPickUpDropOffListData.map((item) => {
                    if (item.secondaryAddress) {
                      return (
                        <favAddressselectorInList
                          onClick={() => {
                            this.handleList(item);
                          }}
                        >
                          <name> {item.address}</name>
                          <addres> {item.secondaryAddress}</addres>
                        </favAddressselectorInList>
                      );
                    } else {
                      return (
                        <serviceselectorInList
                          onClick={() => {
                            this.handleList(item);
                          }}
                        >
                          <addressEllipce> {item.address}</addressEllipce>
                        </serviceselectorInList>
                      );
                    }
                  })}

                {this.props.suggestListPickUpDropOffLoading && (
                  <div>
                    <span
                      className="NotravelsListHeader"
                      style={{ marginTop: "10px" }}
                    >
                      <Trans i18nKey={"poperLoading"}> </Trans>
                    </span>
                    <span className="NotravelsListText">
                      <Trans i18nKey={"fetchingdata"}> </Trans>
                    </span>
                  </div>
                )}

                {!this.props.suggestListPickUpDropOffLoading && !isEmpty(this.props.address) &&
                  this.props.suggestPickUpDropOffListData.length === 0 && (
                    <div>
                      <span
                        className="NotravelsListHeader"
                        style={{ marginTop: "10px" }}
                      >
                        <Trans i18nKey={"Noinformationfound"}> </Trans>
                      </span>
                      <span className="NotravelsListText">
                        <Trans i18nKey={"Pleasetryanotherkeyword"}> </Trans>
                      </span>
                    </div>
                  )}

                {!this.props.suggestListPickUpDropOffLoading && isEmpty(this.props.address) &&
                  this.props.suggestPickUpDropOffListData.length === 0 && (
                    <div>
                      <span
                        className="NotravelsListHeader"
                        style={{ marginTop: "10px" }}
                      >
                        <Trans i18nKey={"Pleasetypeyourwordstosearch"}> </Trans>
                      </span>
                      <span className="NotravelsListText">
                      </span>
                    </div>
                  )}
              </div>
            </Paper>
          </Popper>
        </BackdropCustom>
      </passerngerContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  mapRef: state.Map.mapRef,
  Addressbooklist: state.Addressbook.list,
  address: state.NewOrder.newOrder.pickup.address,
  adresss_loc: state.NewOrder.newOrder.pickup.adresss_loc,
  block: state.NewOrder.newOrder.pickup.block,
  floor: state.NewOrder.newOrder.pickup.floor,
  unit: state.NewOrder.newOrder.pickup.unit,
  senderFullName: state.NewOrder.newOrder.pickup.senderFullName,
  addressDetails: state.NewOrder.newOrder.pickup.addressDetails,

  senderPhoneNumber: state.NewOrder.newOrder.pickup.senderPhoneNumber,
  noteForDriver: state.NewOrder.newOrder.pickup.noteForDriver,
  email: state.NewOrder.newOrder.pickup.email,
  scheduleDateBefore: state.NewOrder.newOrder.pickup.scheduleDateBefore,
  scheduleDateAfter: state.NewOrder.newOrder.pickup.scheduleDateAfter,
  list: state.NewOrder.newOrder.pickup.list,
  loading: state.NewOrder.newOrder.pickup.loading,
  activePickupDropOff: state.NewOrder.newOrder.activePickupDropOff,
  center: state.Map.center,
  suggestListPickUpDropOffLoading:
    state.NewOrder.newOrder.suggestListPickUpDropOffLoading,
  suggestListPickUpDropOffOrdered:
    state.NewOrder.newOrder.suggestListPickUpDropOffOrdered,
  suggestPickUpDropOffListData:
    state.NewOrder.newOrder.suggestPickUpDropOffListData,
  activeVehicleType: state.NewOrder.newOrder.service.activeVehicleType,
  addressBookSource: state.Addressbook.openAddressBookInNewOrder
    ? state.Addressbook.sourceOfAddressBookInNewOrder
      ? state.Addressbook.sourceOfAddressBookInNewOrder.type == "pickup"
      : false
    : false,

  selectedAB: state.Addressbook.selectedAB,
  openAddressBook: state.Addressbook.openAddressBookInNewOrder,
  pickupDropOffType: state.NewOrder.newOrder.map_Data.pickupDropOff.type,
  pickupDropOffId: state.NewOrder.newOrder.map_Data.pickupDropOff.id,
  serviceactiveVehicleType: state.NewOrder.newOrder.service.activeVehicleType,

});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
